export default __webpack_public_path__ + "static/media/RelocateBoxIcon.5a5626a8.svg";